import React from "react";
import styles from "./Button.module.scss";
import classNames from "classnames";

export type ButtonStatus =
  | "enabled"
  | "disabled"
  | "loading"
  | "done"
  | "alert";
export type ButtonSize = "small" | "medium" | "large";

export type ButtonProps = {
  /**
   * Состояние кнопки (влияет на внешний вид и возможность нажать ее).
   * По умолчанию: "enabled"
   */
  status?: ButtonStatus;
  /** Размер кнопки, по умолчанию medium */
  size?: ButtonSize;
  /** Текст кнопки */
  title: string;
  /** Тип */

  type?: "button" | "submit";
  wfull?: boolean;
};

const Button: React.FC<ButtonProps & React.ComponentProps<"button">> = ({
  title,
  status = "enabled",
  size = "medium",
  type = "button",
  wfull = false,
  ...restProps
}) => {
  return (
    <button
      type={type}
      className={classNames(styles.button, styles[size], styles[status], {
        [styles.wide]: wfull,
      })}
      disabled={status === "disabled"}
      {...restProps}
    >
      {title}
    </button>
  );
};

export default Button;
